// Modo coringa "Ver como" — só admin da allowlist pode simular outro papel
// (líder, recepção, professor). "Professor" precisa de identidade real
// (professorId) pois aulas.professor_id tem FK → professores.id (admin não tem
// linha lá). Guardado em sessionStorage (não sobrevive a fechar a aba); quem
// muda recarrega a página pra re-rodar toda a identificação de usuário/role.

const KEY = "ironhouse_view_as";

// Fonte ÚNICA de quem pode usar o coringa. Antes vivia só no NovaShell, o que
// deixava o botão escondido mas o modo AINDA aplicado — ver comentário no
// getViewAs.
export const VER_COMO_EMAILS = [
  "rodncb@gmail.com",
  "talesrocha@facilitaai.com.br",
];

export const podeUsarVerComo = (email) =>
  !!email && VER_COMO_EMAILS.includes(email);

// `email` = do usuário logado AGORA. Devolve o modo coringa só se ele tiver
// sido ligado por esse mesmo usuário E se esse usuário puder usar o recurso.
//
// ⚠️ Bug corrigido 27/07 (o Marco reclamou): o sessionStorage é por ABA, não
// por usuário, e nada amarrava o modo a quem o ligou. Duas formas de ficar
// preso vendo tela de professor:
//   1. até 21/07 o coringa era liberado por `role === 'admin'`, então o Marco
//      (admin) podia ligá-lo. A allowlist chegou depois e só escondeu o BOTÃO
//      — o valor gravado seguia sendo aplicado e ele não tinha como desligar;
//   2. sair e entrar com outra conta na mesma aba: o logout não limpava nada e
//      o modo do usuário anterior valia pro novo, se ele também fosse admin.
// Agora o modo é ignorado se não bater o dono ou se ele não estiver na
// allowlist — quem está preso destrava sozinho no próximo carregamento.
export const getViewAs = (email) => {
  try {
    if (!podeUsarVerComo(email)) return null;
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const viewAs = JSON.parse(raw);
    if (viewAs?.porEmail !== email) return null;
    return viewAs;
  } catch {
    return null;
  }
};

// `email` de quem está ligando o modo — fica gravado junto pra amarrar o
// coringa ao dono.
export const setViewAs = (viewAs, email) => {
  sessionStorage.setItem(KEY, JSON.stringify({ ...viewAs, porEmail: email }));
  window.location.reload();
};

export const clearViewAs = () => {
  sessionStorage.removeItem(KEY);
  window.location.reload();
};

// Some com o modo SEM recarregar — pro logout, onde a troca de sessão já
// dispara a re-renderização.
export const descartarViewAs = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* sessionStorage indisponível: nada a fazer */
  }
};
